import styled from 'styled-components';

export const FootnoteRendererStyle = styled.ul`
	display: grid;
	row-gap: 0.5rem;
	column-gap: 1rem;
	grid-template-columns: auto 1fr;
`;
